/**
 * Lucide icons — hydrate [data-lucide] elements
 */
import { createIcons, icons } from 'lucide';

function hydrateLucide(root = document) {
  createIcons({ icons, attrs: { 'stroke-width': 1.75 }, nameAttr: 'data-lucide' });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => hydrateLucide());
} else {
  hydrateLucide();
}

window.hydrateLucide = hydrateLucide;

export { hydrateLucide };
